// SPDX-License-Identifier: GPL-3.0-or-later

import { el } from './dom';

type Check = { label: string; ok: boolean; detail?: string };

function check(label: string, fn: () => boolean | string): Check {
  try {
    const result = fn();
    return typeof result === 'string'
      ? { label, ok: true, detail: result }
      : { label, ok: result };
  } catch (err) {
    return { label, ok: false, detail: err instanceof Error ? err.message : String(err) };
  }
}

export function renderSmoke(): HTMLElement {
  const checks: Check[] = [
    check('crossOriginIsolated', () => crossOriginIsolated),
    check('SharedArrayBuffer', () => {
      const sab = new SharedArrayBuffer(8);
      return `${sab.byteLength} bytes`;
    }),
    check('File System Access (showDirectoryPicker)', () => 'showDirectoryPicker' in window),
    check('IndexedDB', () => 'indexedDB' in window),
    check('BroadcastChannel', () => 'BroadcastChannel' in window),
    check('Service Worker', () => 'serviceWorker' in navigator),
  ];

  const dl = el('dl', {});
  for (const c of checks) {
    dl.append(
      el('dt', {}, c.label),
      el(
        'dd',
        { class: c.ok ? 'ok' : 'bad' },
        c.ok
          ? `OK${c.detail ? ` — ${c.detail}` : ''}`
          : `FAIL${c.detail ? ` — ${c.detail}` : ''}`,
      ),
    );
  }

  return el(
    'section',
    { class: 'smoke' },
    el('h2', { style: 'font-family: var(--font-serif); font-style: italic; font-size: 2rem;' }, 'Smoke'),
    el('p', { style: 'color: var(--text-secondary); margin-top: 0.5rem;' }, 'Browser capability check. Used to verify hosting headers in Phase 0.'),
    dl,
  );
}
